import { ICompany } from '../company.model';
import { IPlace } from '../place.model';
import { ITruckImplement } from '../truck-implement.model';
import { IUser } from '../user.model';
import { IMaintenancePartDTO } from './maintenance-part-dto.model';

export interface IMaintenanceVehicleDTO {
  id?: number;
  code?: string | null;
  serviceOrder?: string | null;
  created?: string | null;
  km?: number | null;
  age?: number | null;
  hour?: number | null;
  proofContentType?: string | null;
  proof?: string | null;
  objectKey?: string | null;
  description?: string | null;
  manual?: boolean | null;
  blocked?: boolean | null;
  reviewOrder?: number | null;
  lastMaintenance?: string | null;
  truckImplement?: ITruckImplement | null;
  company?: ICompany | null;
  user?: IUser | null;
  place?: IPlace | null;
  maintenancePartsDTO?: IMaintenancePartDTO[];
  maintenanceControlId?: number | null;
}

export const defaultValue: Readonly<IMaintenanceVehicleDTO> = {
  manual: false,
  blocked: false,
};
